import * as React from 'react';

import Back from './Back';
import Base from './Base';
import Logout from './Logout';

import Counter from './Counter';

const SIZE_MOBILE_PX = 425;
const SIZE_LAPTOP_PX = 1024;

/**
 * 0 - Nothing
 * < - Back (Chevron Left)
 * L - Logout (only displayed on non-mobile screen sizes)
 * X - Back (Close)
 *
 * Terms Of Service     X__Logo__0
 * Intent               0__Logo__0
 * Login                0__Logo__0
 * PatientTermsOfUse    0__Logo__0
 * Unsubscribe          0__Logo__0
 * Form Start           0__Logo__L
 * Form                 <__Logo__L
 * Form End             <__Logo__L
 */
export enum View {
  DigitalCheckIn = 'DIGITAL_CHECK_IN',
  Directory = 'DIRECTORY',
  Form = 'FORM',
  FormEnd = 'FORM_END',
  FormStart = 'FORM_START',
  Intent = 'INTENT',
  Login = 'LOGIN',
  Review = 'REVIEW',
  Schedule = 'SCHEDULE',
  PatientTermsOfUse = 'PATIENT_TERMS_OF_USE',
  TermsOfService = 'TERMS_OF_SERVICE',
  Unsubscribe = 'UNSUBSCRIBE',
}

interface Props {
  view: View;
  onBackButtonClicked?: () => void;
}

interface State {
  isMobile: boolean;
  isTablet: boolean;
}

export default class NavBar extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      isMobile: this.calculateIsMobile(),
      isTablet: this.calculateIsTablet(),
    };
  }

  calculateIsMobile = () => window.innerWidth <= SIZE_MOBILE_PX;
  calculateIsTablet = () =>
    window.innerWidth > SIZE_MOBILE_PX && window.innerWidth <= SIZE_LAPTOP_PX;

  handleWindowResize = () => {
    this.setState({
      isMobile: this.calculateIsMobile(),
      isTablet: this.calculateIsTablet(),
    });
  };

  componentDidMount() {
    window.addEventListener('resize', this.handleWindowResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowResize);
  }

  render() {
    const { props, state } = this;
    const { onBackButtonClicked, view } = props;
    const { isMobile, isTablet } = state;
    const isMobileOrTablet = isMobile || isTablet;

    switch (view) {
      case View.Form:
      case View.FormEnd:
        return (
          <Base
            left={<Back onClick={onBackButtonClicked} />}
            right={isMobileOrTablet ? <Counter /> : <Logout />}
          />
        );
      case View.FormStart:
      case View.Review:
        const [leftFormStart, rightFormStart] = isMobileOrTablet
          ? [null, null]
          : [<Counter />, <Logout />];
        return <Base left={leftFormStart} right={rightFormStart} />;
      case View.Directory:
        return <Base directory={true} />;
      case View.DigitalCheckIn:
      case View.Intent:
      case View.Login:
      case View.PatientTermsOfUse:
      case View.Unsubscribe:
        return <Base />;
      case View.Schedule:
        const leftSchedule = isMobileOrTablet ? (
          <Back onClick={onBackButtonClicked} />
        ) : null;
        return <Base left={leftSchedule} />;
      case View.TermsOfService:
        return <Base left={<Back />} right={<Counter />} />;
    }
  }
}
